import { getToken,axiosInstance } from "../utils/Api";
export const deleteCategory = async (id) =>{ 
    try { 
        const response = await axiosInstance.delete(`/admin/game/deleteGameLevel`,{
          data:{game_level_id:id},
            headers: { 
                Authorization: `Bearer ${getToken()}`,
            }
        });
        return response.data; 
      } catch (error) {
        throw error;
      } 
}

export const getCategoryDetails = async (id) =>{ 
  try { 
      const response = await axiosInstance.get(`/admin/game/getGameLevel?id=${id}`,{
        headers: { 
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data; 
    } catch (error) {
      throw error;
    } 
}
 

export const createGamelevel = async (formdata) =>{ 
  try {
      const response = await axiosInstance.post(`/admin/game/addGameLevel`,formdata,{
          headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data;
    } catch (error) {
      throw error;
    } 
} 
 
export const updateCategory = async (formdata) =>{ 
  try {
      const response = await axiosInstance.put("/admin/game/updateGameLevel",formdata,{
          headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data;
    } catch (error) {
      throw error;
    } 
} 
 